import type { ReactNode } from "react";
import { Link, useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";
import { useAuth } from "../lib/auth";

const WEB_URL = import.meta.env.VITE_WEB_URL ?? "https://vietparenting.com";

interface Props {
  children: ReactNode;
}

export default function AppShell({ children }: Props) {
  const auth = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    navigate("/login", { replace: true });
  };

  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-white/75 backdrop-blur-md border-b border-[rgba(109,200,181,0.35)] sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 h-14 flex items-center justify-between gap-4">
          <Link
            to="/admin"
            className="flex items-center gap-2 font-display font-extrabold text-red-700 text-lg"
          >
            <span className="hidden sm:inline">
              Việt <span className="text-red-300">Parenting</span>
            </span>
            <span className="text-[10px] font-bold uppercase tracking-[1.5px] text-red-300 ml-2 px-2 py-0.5 rounded-full bg-red-50">
              Quản lý
            </span>
          </Link>

          <div className="flex items-center gap-3">
            <a
              href={WEB_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-gray-500 hover:text-red-700"
            >
              ↗ Trang chính
            </a>
            {auth.status === "authenticated" && (
              <button
                onClick={handleSignOut}
                className="text-sm font-medium text-gray-600 hover:text-red-700"
              >
                Đăng xuất
              </button>
            )}
          </div>
        </div>
      </header>

      <main className="flex-1">{children}</main>
    </div>
  );
}
